<template class="customer_select_more_style">
  <el-select
      ref="customer_select_more"
      v-model="selectedValues"
      multiple
      filterable
      remote
      reserve-keyword
      :remote-method="remoteMethod"
      :loading="loading"
      :value-key="valueKey"
      @visible-change="handleDropdownVisible"
      @change="handleChange"
  >
    <el-option
        v-for="item in options"
        :key="item[valueKey]"
        :label="item.customerName"
        :value="item.customerName"
    />
    <div v-if="options.length >= total" class="customer_select_no_more"><span>没有更多数据了</span></div>
  </el-select>
</template>
<script>
import { debounce } from 'lodash';
// import { validatenull } from '@/tdcommon/validate'
import { customerMoreSelect } from '@/api/basic/customer'
// 项目名称下拉多选+远程搜索

export default {
  name: 'd2-container-customer-select-more',
  data () {
    return {
      selectedValues: [], // 多选绑定的数组
      options: [], // 当前显示的选项列表
      loading: false, // 加载状态
      page: 1, // 当前页码
      pageSize: 10, // 每页数量
      total: 0, // 总数据量
      keyword: '' // 搜索关键词
    }
  },
  props: {
    valueKey: {
      type: String,
      default: 'customerNo'
    }
  },
  created () {
    // 初始化加载已选中的数据（如果需要）
    this.loadInitialSelectedValues()
    // 防抖处理远程方法
    this.remoteMethod = debounce(this._remoteMethod, 300)
  },
  mounted () {
    this.bindScrollListener()
  },
  beforeDestroy () {
    this.unbindScrollListener()
  },
  methods: {
    remoteMethod (query) {},
    // 加载初始已选中的选项标签
    async loadInitialSelectedValues () {
      const params = {
        inputLike: { customerName: '' },
        oneList: {},
        moreList: {},
        dateList: {},
        current: this.page,
        size: this.pageSize,
        descs: []
      }
      const res = await customerMoreSelect(params)
      this.options = [...res.data.records, ...this.options]
      this.total = res.data.total
    },
    // 实际远程方法
    async _remoteMethod (query) {
      this.keyword = query
      this.page = 1
      await this.loadOptions()
    },
    // 加载选项数据
    async loadOptions () {
      this.loading = true
      try {
        const params = {
          inputLike: { customerName: this.keyword },
          oneList: {},
          moreList: {},
          dateList: {},
          current: this.page,
          size: this.pageSize,
          descs: []
        }
        const res = await customerMoreSelect(params) // 替换为实际API调用
        if (this.page === 1) {
          this.options = res.data.records
        } else {
          this.options.push(...res.data.records)
        }
        this.total = res.data.total
      } catch (error) {
        console.error('error', error)
      } finally {
        this.loading = false
      }
    },
    // 绑定滚动事件监听
    bindScrollListener () {
      this.$nextTick(() => {
        const scrollWrap = this.$refs.customer_select_more.$el.querySelector('.el-select-dropdown__wrap')
        if (scrollWrap) {
          scrollWrap.addEventListener('scroll', this.handleScroll)
        }
      })
    },
    // 解绑滚动事件
    unbindScrollListener () {
      const scrollWrap = this.$refs.customer_select_more.$el.querySelector('.el-select-dropdown__wrap')
      if (scrollWrap) {
        scrollWrap.removeEventListener('scroll', this.handleScroll)
      }
    },
    // 处理滚动加载更多
    handleScroll (event) {
      const { scrollTop, clientHeight, scrollHeight } = event.target
      if (scrollHeight - (scrollTop + clientHeight) < 10 && this.options.length < this.total && !this.loading) {
        this.page += 1
        this.loadOptions()
      }
    },
    // 下拉框显示/隐藏时处理监听器
    handleDropdownVisible (visible) {
      if (visible) {
        this.bindScrollListener()
      } else {
        this.unbindScrollListener()
      }
    },
    handleChange (val) {
      this.$emit('change', val)
    }
  }
}
</script>

<style lang="scss">
.customer_select_more_style {
}
.customer_select_no_more {
  padding: 10px;
  text-align: center;
  color: #999;
  font-size: 13px;
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/d2-container-customer-select-more/index.vue"
}
</vue-filename-injector>
